module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.27073",
      "conversations-internal-schema": "static-1.12993",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8068",
      "hubspot-url-utils": "static-1.4178",
      "HubStyleTokens": "static-2.11525",
      "I18n": "static-7.1633",
      "jasmine-runner": "static-1.6515",
      "quartz": "static-1.7093",
      "react": "static-7.187",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.488",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6191",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "bend-plugin-trellis-migration": "static-1.3440",
      "moment": "static-3.26",
      "customer-data-email": "static-1.18123",
      "cv-backend-services": "static-1.1555",
      "hub-http": "static-1.6274",
      "immutable": "static-2.81",
      "immutable-less": "static-1.4704",
      "quartz-config": "static-1.871",
      "quartz-core": "static-1.6312",
      "transmute": "static-2.85",
      "HeadJS": "static-2.765",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8029",
      "framer-motion": "static-1.73",
      "hs-test-utils-bend-plugin": "static-1.3179",
      "msw": "static-1.39",
      "react-redux": "static-7.73",
      "redux": "static-4.16",
      "testing-library": "static-1.153",
      "foundations-theming": "static-1.4476",
      "i18n-data": "static-1.222",
      "metrics-js": "static-1.9693",
      "moment-timezone": "static-5.84",
      "react-utils": "static-2.5384",
      "jasmine": "static-4.4377",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.67",
      "styled-components": "static-2.91",
      "UIComponents": "static-3.8471",
      "visitor-ui-component-library-icons": "static-1.6002",
      "bender-build-tools": "static-1.3254",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4703",
      "apollo-stack-hubspot": "static-3.87",
      "classnames": "static-2.10",
      "cssUtils": "static-1.804",
      "customer-data-objects": "static-1.7727",
      "customer-data-ui-utilities": "static-1.9877",
      "data-fetching-client": "static-1.9716",
      "FileManagerCore": "static-1.39253",
      "FileManagerLib": "static-1.39394",
      "foundations-assets": "static-1.4921",
      "graphql": "static-1.83",
      "hs-promise-utils": "static-1.5643",
      "hubspot-apollo-client": "static-1.4929",
      "icons": "static-2.650",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.106",
      "react-virtualized": "static-2.100",
      "rpc-client-utils": "static-1.4704",
      "salesImages": "static-1.526",
      "timezone-utils": "static-2.5295",
      "ui-gdpr-components": "static-1.10401",
      "ts-schema": "static-1.4120",
      "hs-locale-management": "static-1.121",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.137",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.839",
      "hubspotter-http": "static-1.4691",
      "mobile-manifest-mixins": "static-1.539",
      "module-federation": "static-1.24",
      "quartz-auth": "static-1.768",
      "quartz-head": "static-1.758",
      "quartz-i18n": "static-1.768",
      "quartz-routing": "static-1.523",
      "quartz-test": "static-1.768",
      "quartz-tracking": "static-1.472",
      "quick-fetch": "static-1.3958",
      "react-rhumb": "static-1.16729",
      "ui-fonts": "static-1.787",
      "usage-tracker-container": "static-1.7391",
      "usage-tracker-core": "static-1.7251",
      "bend-plugin-foundations-components": "static-1.4298",
      "floating-ui": "static-1.57",
      "foundations-theming-specialty": "static-1.2192",
      "hs-story-utils": "static-1.9475",
      "react-create-root-preference": "static-1.31",
      "tanstack-table": "static-1.56",
      "trellis-assets": "static-1.2073",
      "ui-images": "static-2.1165",
      "bend-plugin-foundations-theming": "static-1.2959",
      "foundations-theming-base": "static-1.3461",
      "stylex": "static-1.34",
      "HubStyle": "static-2.11832",
      "sassPrefix": "static-1.157",
      "inbound-db-properties-service-client": "static-1.3886",
      "property-translator": "static-1.5450",
      "react-dnd-compat": "static-1.4665",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9095",
      "audio-components": "static-1.5993",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29390",
      "file-manager-components": "static-1.23754",
      "FileManagerImages": "static-1.36905",
      "foundations-components-legacy": "static-1.1054",
      "immerable": "static-1.4205",
      "react-colorpicker": "static-2.10260",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.9040",
      "urlinator": "static-1.4589",
      "video-components": "static-1.13459",
      "video-data-lib": "static-1.35115",
      "video-embed": "static-1.35949",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.388",
      "bend-plugin-chirp-manifest": "static-1.114",
      "chirp-fetch": "static-1.1939",
      "hub-http-shared-msw-handlers": "static-1.10086",
      "hubspotter-http-shared-msw-handlers": "static-1.10084",
      "usage-tracker-session-replay": "static-1.5087",
      "web-vitals": "static-1.7",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.21515",
      "ContentUtils": "static-1.68513",
      "copilot-toolkit": "static-1.11269",
      "customer-data-objects-ui-components": "static-1.13082",
      "sanitize": "static-1.4528",
      "sanitize-text": "static-1.8194",
      "content-assistance-lib": "static-1.7830",
      "usage-tracker": "static-1.7401",
      "ui-addon-iframeable": "static-1.9111",
      "video-components-external": "static-1.11457",
      "unified-auth-core-lib": "static-1.836",
      "content-icons-ui": "static-1.2239",
      "social-insights-client-types": "static-1.22239",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4228",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4864",
      "integrations-lib": "static-1.16328",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.833",
      "magpie-lib": "static-1.5585",
      "magpie-types": "static-1.5045",
      "simple-logging-lib": "static-1.3102",
      "atom": "static-1.5126",
      "avatar-components": "static-1.2550",
      "reference-resolvers": "static-1.8223",
      "superstore": "static-1.4812",
      "ui-addon-video-player": "static-1.8755",
      "ui-coaching-tips": "static-1.28702",
      "navigation-messaging": "static-1.7492",
      "content-media-composition-data-lib": "static-1.12524",
      "content-media-compositions": "static-2.16531",
      "idb-keyval": "static-1.45",
      "media-bridge-lib": "static-1.19017",
      "fsm": "static-1.3782",
      "flux-actions": "static-1.341",
      "frontend-preferences-client": "static-1.7978",
      "integrations-error-boundary-lib": "static-1.13743",
      "integrations-tracking-lib": "static-1.5654",
      "laboratory-lib": "static-3.7207",
      "native-integrations-shared-strings": "static-1.7833",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10416",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11203",
      "ui-shepherd-react": "static-3.10263",
      "unified-auth": "static-1.554",
      "breeze-engine-core": "static-1.111",
      "ably": "static-2.2",
      "highlight.js": "static-1.80",
      "reactive-lib": "static-1.775",
      "growth-onboarding-feedback-components": "static-1.6631",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.3067",
      "foundations-components-test-utils": "static-1.5512",
      "ads-unified-auth-lib": "static-1.27",
      "google-sheets-integration-lib": "static-1.385",
      "microsoft-drive-integration-lib": "static-1.519",
      "slack-ui-library": "static-1.10443",
      "react-dlb": "static-1.80",
      "crm-record-cards-service-types": "static-1.3630",
      "framework-data-schema-resolvers": "static-1.6939",
      "location-customization-utils-lib": "static-1.9408",
      "batch-promise": "static-1.1593",
      "conditional-properties-service-client": "static-1.3838",
      "crm-pipelines-api-client-types": "static-1.4180",
      "fdsr-migration-layer": "static-1.58",
      "framework-builder-read-service-client": "static-1.4045",
      "framework-data-schema-quick-fetch": "static-1.6844",
      "inbound-db-meta-service-client": "static-1.3626",
      "multi-currency-client-types": "static-1.3732",
      "persist-promise": "static-1.3750"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.27073",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12993",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8068",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4178",
      "HubStyleTokens": "/HubStyleTokens/static-2.11525",
      "I18n": "/I18n/static-7.1633",
      "jasmine-runner": "/jasmine-runner/static-1.6515",
      "quartz": "/quartz/static-1.7093",
      "react": "/react/static-7.187",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.488",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6191",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3440",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.18123",
      "cv-backend-services": "/cv-backend-services/static-1.1555",
      "hub-http": "/hub-http/static-1.6274",
      "immutable": "/immutable/static-2.81",
      "immutable-less": "/immutable-less/static-1.4704",
      "quartz-config": "/quartz-config/static-1.871",
      "quartz-core": "/quartz-core/static-1.6312",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.765",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8029",
      "framer-motion": "/framer-motion/static-1.73",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3179",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.73",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.153",
      "foundations-theming": "/foundations-theming/static-1.4476",
      "i18n-data": "/i18n-data/static-1.222",
      "metrics-js": "/metrics-js/static-1.9693",
      "moment-timezone": "/moment-timezone/static-5.84",
      "react-utils": "/react-utils/static-2.5384",
      "jasmine": "/jasmine/static-4.4377",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.67",
      "styled-components": "/styled-components/static-2.91",
      "UIComponents": "/UIComponents/static-3.8471",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6002",
      "bender-build-tools": "/bender-build-tools/static-1.3254",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4703",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.804",
      "customer-data-objects": "/customer-data-objects/static-1.7727",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9877",
      "data-fetching-client": "/data-fetching-client/static-1.9716",
      "FileManagerCore": "/FileManagerCore/static-1.39253",
      "FileManagerLib": "/FileManagerLib/static-1.39394",
      "foundations-assets": "/foundations-assets/static-1.4921",
      "graphql": "/graphql/static-1.83",
      "hs-promise-utils": "/hs-promise-utils/static-1.5643",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4929",
      "icons": "/icons/static-2.650",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.106",
      "react-virtualized": "/react-virtualized/static-2.100",
      "rpc-client-utils": "/rpc-client-utils/static-1.4704",
      "salesImages": "/salesImages/static-1.526",
      "timezone-utils": "/timezone-utils/static-2.5295",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10401",
      "ts-schema": "/ts-schema/static-1.4120",
      "hs-locale-management": "/hs-locale-management/static-1.121",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.137",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.839",
      "hubspotter-http": "/hubspotter-http/static-1.4691",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
      "module-federation": "/module-federation/static-1.24",
      "quartz-auth": "/quartz-auth/static-1.768",
      "quartz-head": "/quartz-head/static-1.758",
      "quartz-i18n": "/quartz-i18n/static-1.768",
      "quartz-routing": "/quartz-routing/static-1.523",
      "quartz-test": "/quartz-test/static-1.768",
      "quartz-tracking": "/quartz-tracking/static-1.472",
      "quick-fetch": "/quick-fetch/static-1.3958",
      "react-rhumb": "/react-rhumb/static-1.16729",
      "ui-fonts": "/ui-fonts/static-1.787",
      "usage-tracker-container": "/usage-tracker-container/static-1.7391",
      "usage-tracker-core": "/usage-tracker-core/static-1.7251",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4298",
      "floating-ui": "/floating-ui/static-1.57",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2192",
      "hs-story-utils": "/hs-story-utils/static-1.9475",
      "react-create-root-preference": "/react-create-root-preference/static-1.31",
      "tanstack-table": "/tanstack-table/static-1.56",
      "trellis-assets": "/trellis-assets/static-1.2073",
      "ui-images": "/ui-images/static-2.1165",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2959",
      "foundations-theming-base": "/foundations-theming-base/static-1.3461",
      "stylex": "/stylex/static-1.34",
      "HubStyle": "/HubStyle/static-2.11832",
      "sassPrefix": "/sassPrefix/static-1.157",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3886",
      "property-translator": "/property-translator/static-1.5450",
      "react-dnd-compat": "/react-dnd-compat/static-1.4665",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9095",
      "audio-components": "/audio-components/static-1.5993",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29390",
      "file-manager-components": "/file-manager-components/static-1.23754",
      "FileManagerImages": "/FileManagerImages/static-1.36905",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1054",
      "immerable": "/immerable/static-1.4205",
      "react-colorpicker": "/react-colorpicker/static-2.10260",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.9040",
      "urlinator": "/urlinator/static-1.4589",
      "video-components": "/video-components/static-1.13459",
      "video-data-lib": "/video-data-lib/static-1.35115",
      "video-embed": "/video-embed/static-1.35949",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.388",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.114",
      "chirp-fetch": "/chirp-fetch/static-1.1939",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10086",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10084",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5087",
      "web-vitals": "/web-vitals/static-1.7",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.21515",
      "ContentUtils": "/ContentUtils/static-1.68513",
      "copilot-toolkit": "/copilot-toolkit/static-1.11269",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13082",
      "sanitize": "/sanitize/static-1.4528",
      "sanitize-text": "/sanitize-text/static-1.8194",
      "content-assistance-lib": "/content-assistance-lib/static-1.7830",
      "usage-tracker": "/usage-tracker/static-1.7401",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9111",
      "video-components-external": "/video-components-external/static-1.11457",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.836",
      "content-icons-ui": "/content-icons-ui/static-1.2239",
      "social-insights-client-types": "/social-insights-client-types/static-1.22239",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4228",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4864",
      "integrations-lib": "/integrations-lib/static-1.16328",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.833",
      "magpie-lib": "/magpie-lib/static-1.5585",
      "magpie-types": "/magpie-types/static-1.5045",
      "simple-logging-lib": "/simple-logging-lib/static-1.3102",
      "atom": "/atom/static-1.5126",
      "avatar-components": "/avatar-components/static-1.2550",
      "reference-resolvers": "/reference-resolvers/static-1.8223",
      "superstore": "/superstore/static-1.4812",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8755",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28702",
      "navigation-messaging": "/navigation-messaging/static-1.7492",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12524",
      "content-media-compositions": "/content-media-compositions/static-2.16531",
      "idb-keyval": "/idb-keyval/static-1.45",
      "media-bridge-lib": "/media-bridge-lib/static-1.19017",
      "fsm": "/fsm/static-1.3782",
      "flux-actions": "/flux-actions/static-1.341",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7978",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13743",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5654",
      "laboratory-lib": "/laboratory-lib/static-3.7207",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7833",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10416",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11203",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10263",
      "unified-auth": "/unified-auth/static-1.554",
      "breeze-engine-core": "/breeze-engine-core/static-1.111",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.80",
      "reactive-lib": "/reactive-lib/static-1.775",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6631",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3067",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5512",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.27",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.385",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.519",
      "slack-ui-library": "/slack-ui-library/static-1.10443",
      "react-dlb": "/react-dlb/static-1.80",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3630",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6939",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9408",
      "batch-promise": "/batch-promise/static-1.1593",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3838",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4180",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.58",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4045",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6844",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3626",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3732",
      "persist-promise": "/persist-promise/static-1.3750"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.27073",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};